<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head.head-border
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb(:data="items")
        el-col.pt-5.text-right(:span="15")
          el-button(v-show="head.state==2" type="primary" :loading="loading" size="mini" @click="preserve") 完结签收
          el-button(type="primary" size="mini" :loading="logistics_loading" :disabled="parseInt(head.trans_way)===1" @click="getLogistics(head.code)") 查看物流
          el-button(type="primary" size="mini" @click="$router.go(-1)") 返回
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      el-row
        el-col(:span="20")
          div 发货单信息
      el-form.mt-4(label-width="100px" size="mini")
        el-row
          el-col(:span="7")
            el-form-item(label="运输工具:")
              span {{parseInt(head.trans_way)===0?'物流':'车/船运'}}
          el-col(:span="7")
            el-form-item(v-if="parseInt(head.trans_way) === 0" label="物流公司:")
              span {{head.name_trans_org}}
            el-form-item(v-else label="车/船号:")
              span {{head.trans_no}}
          el-col(:span="7")
            el-form-item(v-if="parseInt(head.trans_way) === 0" label="物流单号:")
              span {{head.trans_code}}
        el-row
          el-col(:span="7")
            el-form-item(label="发货单号:")
              span {{head.code}}
            el-form-item(label="发货日期:")
              span {{head.trans_date}}
            el-form-item(label="收货人:")
              span {{head.name_link}}
            el-form-item(label="收货地址:")
              span {{head.address}}
          el-col(:span="7")
            el-form-item(label="供应商:")
              span {{head.name_supplier}}
            el-form-item(label="需求组织:")
              span {{head.order_date}}
            el-form-item(label="签收日期:")
              span {{head.sign_date}}
          el-col(:span="7")
            el-form-item(label="联系方式:")
              span {{head.mobile_buy_person}}
            el-form-item(label="采购组织:")
              span {{head.name_buy_org}}
            el-form-item(label="状态:")
              span {{head.name_state}}
      el-row.mt-5
        el-col(:span="20")
          div 物料信息
      el-table(:data="body" style="width: 100%"  size="mini")
        el-table-column(prop="row_num" label="行号" width="50")
        el-table-column(prop="row_num" label="订单号" width="150")
        el-table-column(prop="code_material" label="物料编码" width="150")
        el-table-column(prop="name_material" label="物料名称" width="150")
        el-table-column(prop="num" label="订单数量" width="80")
        el-table-column(prop="remain_num" label="可发货数量" width="80")
        el-table-column(prop="unit_material" label="单位" width="50")
        el-table-column(prop="wish_date" label="期望到货日期" width="100")
        el-table-column(prop="actual_num" label="实发数量" width="80")
        el-table-column(prop="expect_date" label="预计到货时间" width="100")
        el-table-column(prop="remark" label="备注" width="100")
        el-table-column(prop="name_state" label="退换状态" width="80")
    el-dialog.dialog(title="物流信息" :visible.sync="dialogTimeline" width="600px" :destroy-on-close="true" :append-to-body="true" :close-on-press-escape="false")
      div 物流公司: {{logistics.expName}}
      div 订单历时: {{logistics.takeTime}}
      el-timeline.mt-4
        el-timeline-item(v-if="logistics.list" v-for="(item, index) in logistics.list" :key="index" :timestamp="item.time") {{item.status}}
</template>
<script>
export default {
  data() {
    return {
      h: "",
      data: {},
      head: {},
      body: [],
      loading: false,
      items: [
        {
          path: "/purchase/purchase_order",
          meta: {
            title: "发货单"
          }
        },
        {
          path: this.$route.path,
          meta: {
            title: "详情"
          }
        }
      ]
    };
  },
  props: {
    id: {
      type: String,
      default: null
    },
    type: {
      type: [Number, String],
      default: 1
    }
  },
  methods: {
    async preserve() {
      this.head.state = 3;
      this.loading = true;
      let res = await this.$api.invoice.updateHead([this.head]);
      this.loading = false;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success"
        });
        this.$router.go(-1);
      }
    },
    async getById() {
      let res = await this.$api.invoice.getById(this.id);
      if (res) {
        this.data = res.data;
        this.head = res.data.head;
        this.body = res.data.body;
      }
    }
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    this.getById();
  }
};
</script>